/**
 * Vishram — interaction layer
 * Scroll reveals, cursor-reactive hero orbs, 3D card tilt, magnetic buttons,
 * and the mobile nav toggle. Motion effects gated behind prefers-reduced-motion.
 * The nav toggle is bound BEFORE the reduced-motion early return so it always works.
 * Isolated in try/catch so a failure here can't take down other modules.
 */
(function () {
  'use strict';
  if (window.__vishramInteractionsInit) { return; }
  window.__vishramInteractionsInit = true;

  try {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var toggle = document.querySelector('[data-vishram-nav-toggle]');
    var links = document.querySelector('[data-vishram-nav-links]');
    if (toggle && links) {
      toggle.addEventListener('click', function () {
        var open = links.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var reveals = Array.prototype.slice.call(document.querySelectorAll('[data-vishram-reveal]'));
    if (reduce || typeof window.IntersectionObserver !== 'function') {
      for (var i = 0; i < reveals.length; i++) { reveals[i].classList.add('is-in'); }
    } else {
      var io = new window.IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) { entries[j].target.classList.add('is-in'); io.unobserve(entries[j].target); }
        }
      }, { threshold: 0.15 });
      for (var k = 0; k < reveals.length; k++) { io.observe(reveals[k]); }
    }

    if (reduce) { return; }

    var hero = document.querySelector('[data-vishram-hero]');
    if (hero) {
      var orbGold = hero.querySelector('[data-vishram-orb="gold"]');
      var orbRed = hero.querySelector('[data-vishram-orb="red"]');
      var glow = hero.querySelector('[data-vishram-glow]');
      hero.addEventListener('pointermove', function (ev) {
        try {
          var r = hero.getBoundingClientRect();
          var x = (ev.clientX - r.left) / r.width - 0.5;
          var y = (ev.clientY - r.top) / r.height - 0.5;
          if (orbGold) { orbGold.style.transform = 'translate(' + (x * 40) + 'px,' + (y * 30) + 'px)'; }
          if (orbRed) { orbRed.style.transform = 'translate(' + (x * -34) + 'px,' + (y * -26) + 'px)'; }
          if (glow) { glow.style.opacity = '1'; glow.style.transition = 'opacity 0.4s ease'; glow.style.transform = 'translate(' + (ev.clientX - r.left - 130) + 'px,' + (ev.clientY - r.top - 130) + 'px)'; }
        } catch (e) {}
      });
      hero.addEventListener('pointerleave', function () {
        if (orbGold) { orbGold.style.transform = ''; }
        if (orbRed) { orbRed.style.transform = ''; }
        if (glow) { glow.style.opacity = '0'; }
      });
    }

    var tiltNodes = Array.prototype.slice.call(document.querySelectorAll('[data-vishram-tilt]'));
    for (var t = 0; t < tiltNodes.length; t++) {
      (function (card) {
        card.addEventListener('pointermove', function (ev) {
          try {
            var r = card.getBoundingClientRect();
            var x = (ev.clientX - r.left) / r.width - 0.5;
            var y = (ev.clientY - r.top) / r.height - 0.5;
            card.style.transform = 'rotateY(' + (x * 9) + 'deg) rotateX(' + (-y * 9) + 'deg) translateY(-6px) scale(1.025)';
            card.style.boxShadow = '0 20px 44px rgba(26,18,6,0.30)';
          } catch (e) {}
        });
        card.addEventListener('pointerleave', function () { card.style.transform = ''; card.style.boxShadow = ''; });
      })(tiltNodes[t]);
    }

    var magNodes = Array.prototype.slice.call(document.querySelectorAll('[data-vishram-magnetic]'));
    for (var m = 0; m < magNodes.length; m++) {
      (function (btn) {
        btn.addEventListener('pointermove', function (ev) {
          try {
            var r = btn.getBoundingClientRect();
            var x = ev.clientX - r.left - r.width / 2;
            var y = ev.clientY - r.top - r.height / 2;
            btn.style.transform = 'translate(' + (x * 0.3) + 'px,' + (y * 0.4) + 'px) scale(1.04)';
          } catch (e) {}
        });
        btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
      })(magNodes[m]);
    }
  } catch (err) {
    if (window.console && window.console.error) { window.console.error('vishram interactions error', err); }
  }
})();
